<!-- <div>
    <div class="container-fluid">
    <div class="row">
    <div class="col-sm-6">
    <h1><img src="assets/img/logo.png" alt="User Image">Shaji paints</h1>
    </div>
    <div class="col-sm-6">
    <ol class="breadcrumb float-sm-right">
    <li class="breadcrumb-item bgColour"><a (click)='log_out();'><b>Log out</b></a></li>
    <li class="breadcrumb-item bgColour"><a (click)='ToggleCollapse();'><b>hide</b></a></li>

    </ol>
    </div>
    </div>
    </div>
    </div> -->

<nav>
    <div class="row">
        <div class="col-6">
            <div class="d-flex ms-4">
                <h1><img src="assets/img/logo.png" alt="User Image">Shaji paints</h1>
                <i class="fa-solid fa-align-justify" (click)='ToggleCollapse();'></i>
            </div>
        </div>
        <div class="col-6">
            <div class="d-flex justify-content-end me-3">
                <a #logoutLink (click)='log_out();'  class="logout"><b>Log out</b></a>
            </div>
        </div>
    </div>
    <!-- <ul>
        <li>
            <h1><img src="assets/img/logo.png" alt="User Image">Shaji paints</h1>
        </li>
        <li class="fa-solid fa-align-justify" (click)='ToggleCollapse();'></li>
        <li class="last-child"><a (click)='log_out();'><b>Log out</b></a></li>
    </ul> -->
</nav>